module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.5ce4e52c.eot";